export default "__VITE_ASSET__Dknphtzz__";